import { GenderCode, RoleType } from '@lib/types';

import {
  AddAssociateFormStatus,
  generateAddAssociateStatus,
  validateField,
  FieldStatus,
} from '../viewmodels/AddAssociateFormStatus';

export type updateAction = {
  field: string;
  value: string | null;
};

export const addAssociateFormStatusReducer: (
  state: AddAssociateFormStatus,
  action: updateAction
) => AddAssociateFormStatus = (state, action) => {
  if (action === undefined) {
    return generateAddAssociateStatus();
  }

  const outState = { ...state };
  let err: string | null = null;
  switch (action.field) {
    case 'firstName':
      outState.firstName = validateField('firstName', action.value) as FieldStatus<string>;
      return outState;
    case 'lastName':
      outState.lastName = validateField('lastName', action.value) as FieldStatus<string>;
      return outState;
    case 'gender':
      outState.gender = validateField('gender', action.value) as FieldStatus<GenderCode>;
      return outState;
    case 'dateOfBirth':
      outState.dateOfBirth = validateField('dateOfBirth', action.value) as FieldStatus<string>;
      return outState;
    case 'roleType':
      outState.roleType = validateField('roleType', action.value) as FieldStatus<RoleType>;
      return outState;

    case 'form':
      outState.firstName = validateField('firstName', state.firstName.value ?? null) as FieldStatus<string>;
      outState.lastName = validateField('lastName', state.lastName.value ?? null) as FieldStatus<string>;
      outState.gender = validateField('gender', state.gender.value ?? null) as FieldStatus<GenderCode>;
      outState.dateOfBirth = validateField('dateOfBirth', state.dateOfBirth.value ?? null) as FieldStatus<string>;
      return outState;
    default:
      break;
  }
  return state;
};
